import SectionHeading from "./SectionHeading";
import { plotTimeline } from "@/mocks/movieData";

export default function TimelineSection() {
  return (
    <section id="timeline" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          eyebrow="Pacing"
          title="剧情节奏时间线：什么时候该认真看"
          desc="整体节奏由平缓逐步走向集中。了解大致的情绪分布，可以帮助你安排观看时间，避免在最需要专注的段落被打断。"
        />

        <div className="relative">
          <div className="hidden lg:block absolute top-[42px] left-0 right-0 h-0.5 bg-background-300" />
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {plotTimeline.map((item, idx) => (
              <div key={item.phase} className="relative">
                <div className="flex lg:flex-col items-start lg:items-center gap-3 lg:gap-0 lg:text-center">
                  <span className="relative z-10 w-12 h-12 shrink-0 flex items-center justify-center rounded-full bg-primary-500 text-background-50 font-heading font-bold border-4 border-background-50">
                    {idx + 1}
                  </span>
                  <div className="lg:mt-4">
                    <div className="text-xs font-label text-accent-700 tracking-wide">{item.phase}</div>
                    <h3 className="mt-1 text-base font-semibold text-foreground-950">{item.title}</h3>
                  </div>
                </div>
                <p className="mt-3 lg:mt-3 text-sm text-foreground-600 leading-relaxed lg:text-center">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}